import {SODeleteReport} from '../../core/report/so-delete-report';
import {DeleteEntityProtocol} from 'lionheartland';
import {BaseDelete} from 'lionheartland';


export class RADeleteReport extends BaseDelete implements DeleteEntityProtocol {
  deleteClass = SODeleteReport;
}